import { FeatureManager } from "../../../../core/feature-flags/feature-manager.service";
import { EmployeeService, OnboardingApplicationService } from "../../../../core/services";
import { UtilityService } from "../../../../core/services/utility.service";
import { CancelValue, ValueEmitter } from "../../../shared/modals/modal-types";
import templateUrl from "./add-applicant-to-roster-modal.component.html";
import { IComponentOptions } from "angular";


export const AddApplicantToRosterModalComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: class AddApplicantToRosterModalComponent {
        resolve: any;
        close: ValueEmitter<any>;
        dismiss: ValueEmitter<CancelValue>;

        employee: any;
        showPasswordEditor: boolean;
        constructor(private onboardingApplicationService: OnboardingApplicationService,
            private employeeService: EmployeeService, private featureManager: FeatureManager,
            private utilityService: UtilityService) {
            'ngInject'
        }

        $onInit() {
            this.employee = this.resolve.employee;
            this.featureManager.ensureLoaded().then(featureManager => {
                this.showPasswordEditor = featureManager.isEnabled("security.allowSettingPassword");
            })
        }

        afterSave(employee) {
            // Undo changing the page state.
            window.history.replaceState({}, "Submitted Applications", "Onboarding/SubmittedApplications");

            this.close({ $value: employee });
        }
        saveEmployeementRecord(employee) {
            const office = employee.IcdOffices[0];
            if (office != null) {

                const employeeAssigned = this.onboardingApplicationService.patchOnboardingApplication(
                    office.OnboardingApplicationID,
                    {
                        OnboardingApplicationID: office.OnboardingApplicationID,
                        EmployeeID: employee.EmployeeID,
                        EmployementRecord: this.employeeService.mapIcdOfficeEmployeeToDTO(office)
                    })
                    .then(() => {
                        this.close({ $value: employee });
                    });
                this.utilityService.showLoadingUntilResolved(
                    this.utilityService.alertOnError(employeeAssigned, "Assign failed"));
            }
        }
    }
}

export const AddApplicantToRosterModal = {
    component: "apexAddApplicantToRosterModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'xl',
    backdrop: 'static'
}
